'use client';

import { Apple, GetApp, GooglePlay } from '../../icons';
import { AppDownloaderTab } from '../AppDownloader';
import { Button } from '../Button';

import { CopytradingQr, MainQr } from './assets';
import {
  AppDownloaderButtonsContainer,
  AppDownloaderHint,
  AppDownloaderIconsContainer,
  AppDownloaderQRContainer,
  StyledAppDownloaderTabContent,
  AppDownloaderDownloadApkButton,
  AppDownloaderQrWhiteBorder,
} from './styled';

export const AppDownloaderTabContent = (props: AppDownloaderTab) => {
  const { hint, appLink, apkLink, isMain } = props;

  return (
    <StyledAppDownloaderTabContent>
      <AppDownloaderHint paragraph color="text1" variant="body4">
        {hint}
      </AppDownloaderHint>
      <AppDownloaderQRContainer>
        <AppDownloaderQrWhiteBorder isMain={isMain}>
          {isMain ? <MainQr /> : <CopytradingQr />}
        </AppDownloaderQrWhiteBorder>
      </AppDownloaderQRContainer>
      <AppDownloaderButtonsContainer>
        <a href={appLink.url} target="_blank" rel="noopener noreferrer">
          <Button
            startIcon={
              <AppDownloaderIconsContainer>
                <GooglePlay />
                <Apple />
              </AppDownloaderIconsContainer>
            }
            fullWidth
            variant="contained"
          >
            {appLink.title}
          </Button>
        </a>
        <a href={apkLink.url} target="_blank" rel="noopener noreferrer">
          <AppDownloaderDownloadApkButton fullWidth startIcon={<GetApp />}>
            {apkLink.title}
          </AppDownloaderDownloadApkButton>
        </a>
      </AppDownloaderButtonsContainer>
    </StyledAppDownloaderTabContent>
  );
};
